import { render, staticRenderFns } from "./MakbuzIndirList.vue?vue&type=template&id=af8b764e&scoped=true"
import script from "./MakbuzIndirList.vue?vue&type=script&lang=ts"
export * from "./MakbuzIndirList.vue?vue&type=script&lang=ts"
import style0 from "./MakbuzIndirList.vue?vue&type=style&index=0&id=af8b764e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b764e",
  null
  
)

export default component.exports